import styled from 'styled-components'

import { breakpoint } from 'style/theme'

export default styled.div`
  .title-block {
    text-align: center;
    margin-bottom: 30px;
  }

  .logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .image {
      margin: 8px 28px;
      width: 100px;
      height: 75px;

      img {
        object-fit: contain;
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .logo-container {
      .image {
        margin: 4px 14px;
        width: 80px;
        height: 80px;
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .logo-container {
      .image {
        margin: 6px 10px;
        width: 60px;
        height: 60px;
      }
    }
  }
`
